import React from 'react';

type ChevronRightIconProps = {
  width?: number;
  height?: number;
};

export const ChevronRightIcon: React.FC<ChevronRightIconProps> = ({ width = 12, height = 12 }) => (
  <svg width={width} height={height} viewBox="0 0 7 12" fill="currentColor" aria-hidden="true">
    <path d="M4.6 5.65375L0 1.05375L1.05375 0L6.7075 5.65375L1.05375 11.3075L0 10.2538L4.6 5.65375Z" />
  </svg>
);
